var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSantanderLogoRojo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 14.8C31 16.1 31.4 17.6 31.5 19.1C38.9 21 43.9 25.1 43.8 29.6C43.8 36.2 34 41.5 21.9 41.5C9.8 41.5 0 36.2 0 29.6C0 24.9 5.1 20.8 12.4 18.9C12.4 20.7 12.8 22.5 13.7 24.1L20.6 36C21.1 36.9 21.5 37.9 21.7 38.9L22 38.4C23.7 35.5 23.7 31.8 22 28.9L16.5 19.4C14.8 16.4 14.8 12.8 16.5 9.9L16.8 9.4C17 10.4 17.4 11.4 17.9 12.3L21.1 17.9L26.1 26.6C26.6 27.5 27 28.5 27.2 29.5L27.5 29C29.2 26.1 29.2 22.4 27.5 19.5L22 10C20.3 7.1 20.3 3.4 22 0.5L22.3 0C22.5 1 22.9 2 23.4 2.9L30.2 14.8Z",
    fill: "#EC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantanderLogoRojo);
export default __webpack_public_path__ + "static/media/SantanderLogoRojo.def25d0e7129c3f95474c2f52b5ab0fd.svg";
export { ForwardRef as ReactComponent };